// @flow
import { toDate } from 'date-functions';
// $FlowFixMe - TS file
import env from 'bench-environment';

import describeMonths from './describeMonths';
import type { RequestGeneratorClient } from './types';

const getRequestedDates = monthlyData =>
  monthlyData
    .filter(month => month.categorizeStatus === 'CATEGORIZE_REQUESTED')
    .map(month => toDate(month.month))
    .sort((a, b) => a.getTime() - b.getTime());

const requestCategorization = ({
  monthlyData,
  unifiedBankingEnabled,
  id: clientId,
}: RequestGeneratorClient): string => {
  const requestedDates = getRequestedDates(monthlyData);
  if (requestedDates.length === 0) {
    return '';
  }
  const months = describeMonths(requestedDates);
  return `\
Help us categorize transactions for ${months} by leaving a comment or selecting a suggestion:
${env.location.cwa}${
    unifiedBankingEnabled ? `/client/${clientId}` : ''
  }/accounting/overview/categorize\
`;
};

export default requestCategorization;
